import { call, put } from 'redux-saga/effects';

import { createSettingEmailsRequest, updateSettingEmailsRequest } from '../requests';
import { createSettingEmails, updateSettingEmails } from '../../../actions';

export function* createSettingEmailsService(data) {
  yield put(createSettingEmails(data));
  yield call(createSettingEmailsRequest, data);
}

export function* updateSettingEmailsService(id, data) {
  yield put(updateSettingEmails(id, data));
  yield call(updateSettingEmailsRequest, id, data);
}
